import {call, put, select, takeLatest} from 'redux-saga/effects';
import {
    AGENT_TIMER_REQUEST,
    AGENT_TIMER_SUCCESS,
    AGENT_TIMER_FAIL,
} from '../actions/agent.js';
import Api from '../../Api.js';
import _ from "lodash";



function* handleTaskTimer(action) {

    try {
        const {data} = yield call(Api.getAgentTaskTimer);
        yield put({
            type: AGENT_TIMER_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        yield put({
            type: AGENT_TIMER_FAIL,
            payload: {error: e.response},
        });
    }
}




export default function* watcher() {
    yield takeLatest(AGENT_TIMER_REQUEST, handleTaskTimer);

}
